import setupAppSizeCalculator from '../global/setupAppSizeCalculator';
import '../global/setupTextareaAutogrow';
setupAppSizeCalculator();
window.addEventListener('load', () => {
	try {
		(window as unknown as Record<string, unknown> & { EA?: { init_localLang: (v: boolean) => void } }).EA?.init_localLang(true);
	} catch (e) {
		console.warn('EyeAble init_localLang failed', e);
	}
});
